
import { mapState } from 'vuex'
import dayjs from 'dayjs' // 时间转换
import Fingerprint2 from 'fingerprintjs2'
import axios from 'axios'
import { bus } from '~/assets/js/eventBus'
import { GetBasicData } from '~/utils/utils'
let imgCheckPing = null
export default {
  data() {
    return {
      count: 0,
      showfenxian: false,
      GuoJiDianWei: this.$store.state.riskcontrol['271001'], // 点位控制[国际]
      GuoNeiDianWei: this.$store.state.riskcontrol['271002'], // 点位控制[国内]
      curtime: '',
      step: '',
      ss: '',
      webtype: this.$route?.query?.source
    }
  },
  computed: {
    ...mapState({
      riskShow: 'riskShow',
      cookieHost: 'cookieHost'
    })
  },
  destroyed() {
    imgCheckPing = null
  },
  mounted() {
    this.getRiskModule()
    console.log('pingbi-gj', this.GuoJiDianWei)
    console.log('pingbi-gn', this.GuoNeiDianWei)
  },
  methods: {
    getRiskModule() {
      let ss = ''
      ss += 'ck-1111'
      const that = this
      if (!this.curtime) {
        this.curtime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      ss += 'ck-2222'
      const jgpass = this.$Cookie.get('jgpass_new')
      const myip = this.$store.state.userIp
      if (!myip) {
        console.log('this.$store.state.userIp取值异常1,ip=' + myip)
      }
      ss += 'ck-3333'
      const myCountry = this.$store.state.myCountry
      ss += '(myCountry=' + myCountry + ')'
      if (!myCountry) {
        console.log('this.$store.state.myCountry异常,数据丢失,myCountry =' + myCountry)
      }
      ss += 'ck-4444'
      const popred = this.$store.state.isWiki == '1' || this.$store.state.cookieHost.includes('wikifx.hk') ? this.GuoJiDianWei == '1' : this.GuoNeiDianWei == '1'
      ss += '[popred=' + popred + ']'

      // 排除pwa和app[即pwa和app嵌套fx页面，不处红框]
      const openFrom = this.$route.query.from
      const openType = this.$route.query.type
      if (openFrom == 'pwa' || openFrom == 'app' || openType == 'pwa' || openType == 'app') {
        that.showfenxian = false
        return
      }

      if (jgpass != '1' && popred) {
        ss += 'ck-5555'
        if (myCountry == 'cn') {
          ss += 'ck-6666'
          if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
            that.showfenxian = true
            console.log('Safari浏览器')
          } else {
            console.log('非Safari浏览器')
            that.ipInChinaFn(
              function () {
                ss += 'ck-7777'
                that.showfenxian = false
              },
              function () {
                ss += 'ck-8888'
                that.showfenxian = true
                bus.$emit('popRiskRed', true)
              }
            )
          }
        } else {
          that.showfenxian = true
          ss += 'ck-9999'
          bus.$emit('popRiskRed', true)
        }
        ss += 'ck-aaaa'
        this.sendAnalyticsEvent('mark', '')
      }
      ss += 'ck-bbbb'
      ss += '(showfenxian=' + that.showfenxian + ')'
      this.ss = ss
    },
    AddTime(time) {
      let dateTime = new Date()
      dateTime = new Date(dateTime.setTime(dateTime.getTime() + time * 1000))
      return dateTime
    },
    async checkGoogleWebsite() {
      try {
        const response = await axios.head('https://googleads.g.doubleclick.net')
        if (response.status >= 200 && response.status < 300) {
          return true
        }
        return false
      } catch (error) {
        return false
      }
    },
    checkGoogleImg() {
      return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous' // 允许跨域
        img.src = 'https://www.google.com/favicon.ico?' + Date.now() // 添加时间戳
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
      })
    },
    ipInChinaFn(func1, func2) {
      const that = this
      let hasFinish = false

      imgCheckPing = new Image()
      const src = that.GetNewUrl()
      imgCheckPing.src = src
      imgCheckPing.onload = function () {
        if (!hasFinish) {
          this.ss += 'p-333,'
          hasFinish = true
          console.log('Ping ' + src + ' success. ')
          func1()
        }
      }
      imgCheckPing.onerror = function () {
        if (!hasFinish) {
          this.ss += 'p-666,'
          hasFinish = true
          console.log('Ping ' + src + ' error. ')
          func2()
        }
      }
      setTimeout(function () {
        if (!hasFinish) {
          this.ss += 'p-eee,'
          hasFinish = true
          console.log('Ping ' + src + ' timeout(1.5s). ')
          imgCheckPing.src = 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico'
          func2()
        }
      }, 1500)
    },
    eventclick() {
      this.count++
      if (this.count >= 7) {
        this.sendAnalyticsEvent('unmark', '')
        this.$Cookie.set('jgpass_new', '1', {
          path: '/',
          expires: this.AddTime(720 * 60),
          domain: this.cookieHost
        })
        window.location.reload()
      }
      setTimeout(() => {
        this.count = 0
      }, 30000)
    },
    sendAnalyticsEvent(eventName, params) {
      // const bfp = this.$cookies.get('wiki-bfp') || '822ca7b3261a0b2ec10c8cdabfb5a0ea'
      let bfp = ''
      if (this.$cookies.get('wiki-bfp')) {
        bfp = this.$cookies.get('wiki-bfp')
        this.akmfn(bfp, eventName, params)
      } else {
        this.setBfptt((val) => {
          bfp = val
          this.akmfn(bfp, eventName, params)
        })
      }
    },
    akmfn(bfp, eventName, params) {
      const currIPCountry = this.$cookies.get('CURRIPCOUNTRY')
      const basicData = GetBasicData(this.$store.state.isWiki, currIPCountry, bfp)

      setTimeout(() => {
        const url = `https://reportmark.eeeoeee.com/rp.txt?timestamp=${new Date().getTime()}`
        axios
          .get(url, {
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
              event_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              event_name: eventName || '--',
              app_name: 'WikiFx Web',
              user_id: this.$store.state.user.userId || '0',
              basic_data: basicData || '--',
              language_code: this.$store.state.LanguageCode || '--',
              country_code: this.$store.state.CountryCode || '--',
              user_country: this.$cookies.get('CURRIPCOUNTRY') || '--',
              platform: 'wikifx'
            }
          })
          .then(function () {
            console.log('sendAnalyticsEvent success')
          })
          .catch(function (err) {
            console.log('sendAnalyticsEvent fail', err)
          })
      }, 2000)
      // console.log('sendAnalyticsEvent')
    },
    setBfptt(fn) {
      // 浏览器指纹码
      Fingerprint2.get((components) => {
        // 浏览器指纹码
        const values = components.map(function (component, index) {
          if (index == 0) {
            // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
          }
          return component.value
        })
        // 生成最终id murmur
        const murmur = Fingerprint2.x64hash128(values.join(''), 31)
        const now = new Date(new Date(new Date().getTime()).setFullYear(9998, 0, 0))
        this.$Cookie.set('wiki-bfp', murmur, {
          expires: now,
          path: '/',
          domain: this.$store.state.cookieHost
        })
        this.$store.commit('getbfp', murmur)
        fn(murmur)
      })
    },
    GetCurDomain() {
      let dm = this.$store.state.host
      if (process.env.NODE_ENV == 'development' && !window.location.host.includes(dm)) {
        dm = window.location.host
      }
      return dm
    },
    GetNewUrl() {
      return 'https://www.google.com/favicon.ico?' + Math.random()
    }
  }
}
